var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "assist-tabs",
      attrs: { "aria-label": _vm.$t("assistantCatHome.tabs.label") },
    },
    [
      _c("tab-button", {
        attrs: {
          label: _vm.$t("assistantCatHome.tabs.request"),
          "icon-src": _vm.assistIcon,
          "icon-alt": _vm.$t("assistantCatHome.tabs.request"),
          "is-active": _vm.activeTab === "request",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("update:activeTab", "request")
          },
        },
      }),
      _c("tab-button", {
        attrs: {
          label: _vm.$t("assistantCatHome.tabs.history"),
          "icon-src": _vm.historyIcon,
          "icon-alt": _vm.$t("assistantCatHome.tabs.history"),
          "is-active": _vm.activeTab === "history",
        },
        on: {
          click: function ($event) {
            return _vm.$emit("update:activeTab", "history")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }